<div class="header-wrapper container-xl">
  <div class="row no-gutters g-3">
    <div class="col-12 col-lg-4 header-border-lg">
      <div class="row g-2">
        <mpro-country-and-region-selector
          class="col-6"
          [systemRegions]="authResources.regions"
          [systemCountries]="authResources.countries"
          [filters]="dataFilters"
          [doNotShowSubnational]="true"
          [allowMultiSelect]="false"
          (selectionChanged)="onCountryAndRegionChange($event)"
        >
        </mpro-country-and-region-selector>
        <mpro-static-dropdown
          *ngIf="!isCategoriesEnabled"
          class="data-lens col-6"
          [title]="'Subnationals'"
          [options]="dataLensOptions"
          (selectionChanged)="dataLensChanged($event.value)"
          [inputValue]="dataLensInputValue"
        >
        </mpro-static-dropdown>
        <mpro-nested-dropdown
          *ngIf="isCategoriesEnabled"
          class="data-lens col-6"
          [title]="'Categories'"
          [options]="categoriesList"
          (selectionChanged)="onCategoryChange($event.value)"
          [inputValue]="
            getCategoriesValue(categoriesList, dataFilters.category)?.name
          "
          [bgColor]="'#EEF4FF'"
          [bgColorHover]="'#E3EBFF'"
        >
        </mpro-nested-dropdown>
      </div>
    </div>
    <div class="col-12 col-md-8 col-lg-5 header-border-md">
      <div
        class="row g-2 position-relative"
        *ngIf="authService.permissions$ | async as permissions"
      >
        <mpro-loading *ngIf="authResources.areResourcesLoading"></mpro-loading>
        <mpro-age-group-selector
          *ngIf="!permissions.isGenerationsAvailable; else ageGenerations"
          [ngClass]="{
            'col-3': true,
            'col-4': !permissions.isGenerationsAvailable,
            'col-6': !permissions.isGenerationsAvailable && isCategoriesEnabled
          }"
          [inputValue]="dataFilters.ageGroup.displayValue()"
          [userGroups]="customAgeGroups"
          [systemGroups]="authResources.ageGroups"
          (groupClicked)="ageGroupChanged($event)"
          (ageGroupsChanged)="loadRangeCustomFilters()"
        >
        </mpro-age-group-selector>
        <ng-template #ageGenerations>
          <mpro-age-generations-selector
            [ngClass]="{
              'col-4': true,
              'col-6': isCategoriesEnabled
            }"
            [loadRangeCustomFilters]="loadRangeCustomFilters"
            [hideGenerations]="!!dataFilters.regionSelection.isCitySelected()"
          >
          </mpro-age-generations-selector>
        </ng-template>
        <mpro-static-dropdown
          *ngIf="!isCategoriesEnabled"
          class="gender col-4"
          [title]="'Gender'"
          [attr.title]="'Gender'"
          [options]="authResources.genders"
          [inputValue]="
            getNameValuePair(authResources.genders, dataFilters.gender)
          "
          (selectionChanged)="genderChanged($event)"
        >
        </mpro-static-dropdown>
        <div
          [ngClass]="{
            'col-4': true,
            'col-6': isCategoriesEnabled
          }"
        >
          <mpro-spending-group-selector
            *ngIf="
              !(authService.incomeGroupEnabled$ | async);
              else incomeBridges
            "
            [userGroups]="customSpendingGroups"
            [inputValue]="dataFilters.spendingGroup.displayValue()"
            [systemGroups]="
              systemGroupsService.groupedSpendingGroups(
                authResources.spendingGroups
              )
            "
            (groupClicked)="spendingGroupChanged($event)"
            (subgroupClicked)="spendingGroupChanged($event)"
            (spendingGroupsChanged)="loadRangeCustomFilters()"
          >
          </mpro-spending-group-selector>
          <ng-template #incomeBridges>
            <mpro-spending-income-selector
              [spendingGroups]="
                systemGroupsService.groupedSpendingGroups(
                  authResources.spendingGroups
                )
              "
              [inputValue]="dataFilters.spendingGroup.displayValue()"
              [incomeGroups]="authResources.incomeGroups"
              [userSpendingGroups]="customSpendingGroups"
              [userIncomeGroups]="customIncomeGroups"
              [userGroups]="customUserGroups"
              (groupClicked)="spendingGroupChanged($event)"
              (subgroupClicked)="spendingGroupChanged($event)"
              (spendingGroupsChanged)="loadRangeCustomFilters()"
            ></mpro-spending-income-selector>
          </ng-template>
          <span class="spending-group-info-text"
            >Always displayed in 2021 PPP</span
          >
        </div>
      </div>
    </div>
    <div class="col-12 col-md-4 col-lg-3">
      <div class="row g-2">
        <mpro-dashboard-selector
          class="col-12"
          [inputValue]="dataFilters.dashboard"
          [userDashboards]="dashboardFilters"
          [systemDashboards]="constantsItems.data.systemDashboards"
          (dashboardClicked)="onDashboardClicked($event)"
          (dashboardChanged)="loadCustomDashboards()"
        ></mpro-dashboard-selector>
      </div>
    </div>
  </div>
  <div class="row no-gutters g-3">
    <div class="col-11 col-md-10 col-lg-5 row g-2 order-2 order-lg-1">
      <mpro-button-group
        *ngIf="!isCategoriesEnabled"
        class="col-4 col-md-3 col-lg-4"
        title="Spending per"
        [dark]="true"
      >
        <ng-container *ngFor="let b of spendingPer">
          <button
            class="mpro-btn"
            color="blue"
            hue="500"
            *ngIf="!b.hidden"
            mproButtton="secondary"
            [selected]="b.value === dataFilters.spendingPer"
            (click)="onSpendingPerChange(b.value)"
          >
            {{ b.name }}
          </button>
        </ng-container>
      </mpro-button-group>
      <mpro-button-group
        *ngIf="isCategoriesEnabled"
        class="col-4 col-md-3 col-lg-4"
        [dark]="true"
      >
        <ng-container *ngFor="let b of spendingPer">
          <button
            class="mpro-btn-two"
            color="blue"
            hue="500"
            *ngIf="!b.hidden"
            mproButtton="secondary"
            [selected]="b.value === dataFilters.spendingPer"
            (click)="onSpendingPerChange(b.value)"
          >
            {{ b.name }}
          </button>
        </ng-container>
      </mpro-button-group>
      <mpro-button-group
        class="col-8 col-md-9 col-lg-8"
        title="Currency"
        [dark]="true"
      >
        <ng-container *ngFor="let b of currencyView">
          <button
            class="mpro-btn"
            color="blue"
            hue="500"
            mproButtton="secondary"
            [selected]="b.value === dataFilters.currency"
            (click)="onCurrencyViewChange(b.value)"
          >
            {{ b.name }}
          </button>
        </ng-container>
      </mpro-button-group>
      <span *ngIf="!isCategoriesEnabled" class="button-groups-info-text"
        >You're currently looking at
        {{
          dataFilters.currency === 0 ? "2021 PPP USD" : "Nominal Dollars"
        }}.</span
      >
    </div>
    <div class="col-12 col-lg-6 order-1 order-lg-2">
      <mpro-range-slider
        [min]="startYear"
        [max]="endYear"
        [step]="1"
        [arrows]="false"
        [dragBar]="false"
        [bigCircle]="true"
        [clickableTicks]="true"
        [input]="[dataFilters.year]"
        [labelGap]="labelGap"
        (errorChanged)="onErrorChanged($event)"
        (valueChanged)="sliderChanged($event)"
        [customSteps]="(customSteps | async) || []"
        [disabledYears]="disabledYears"
      >
      </mpro-range-slider>
    </div>
    <div class="col-1 col-md-2 col-lg-1 text-right order-last">
      <button
        class="mpro-btn mpro-btn-primary reset-button"
        (click)="resetAll()"
        title="Reset Filters"
      >
        <fa-icon [icon]="faUndo"></fa-icon>
        <span>Reset</span>
      </button>
    </div>
  </div>
</div>
